import { LocalisationDictionary } from './localisationDictionary';

export const daDK: LocalisationDictionary = {
    i18n: {
        global: {
            done: 'Ok',
            redo: 'Tilbage',
            undo: 'Fortryd',
            exitSecondaryCta: 'Er du ikke færdig? Gå tilbage',
            linkLoading: 'Opretter link…',
            linkHelper: 'Linket er nu kopieret',
            linkError: 'Der opstod en fejl - kunne ikke oprette et link',
            linkCta: 'KOPIER',
            checkoutSecondaryCta: 'Vis i dit hjem',
            checkoutPrimaryCta: 'Læg i kurv',
            saveText: 'Gem til senere',
            totalPrice: 'Pris i alt',
            finalise: 'Færdiggør og læg i kurv',
            unknownErrorHeading: 'Der er opstået en ukendt fejl',
            unknownErrorBody: 'Prøv at lukke appen og genåbne den igen',
            shareDrawerHeader: 'Gem og del',
            urlTabHeader: 'URL',
            qrTabHeader: 'QR kode',
            arDrawerHeader: 'Vis i dit hjem',
            qrLoading: 'Genererer QR-kode',
            qrErrorHeading: 'Generering af QR-kode mislykkedes',
            qrErrorMessage: 'Luk venligst dette panel og prøv igen',
            qrCodeDialogHeader:
                'Scan QR-koden på din mobilenhed for at se møblet i dit rum ved hjælp af AR',
            buttonText: 'Vis i dit rum',
            buttonExplainerText: 'Se dette produkt i dit hjem med Augmented Reality',
            incompatibleDeviceDialogHeader: 'Din enhed er ikke AR kompatibel',
            arErrorDialogHeader: 'Det lykkedes ikke at starte AR',
            basketSavingsText: 'Du sparer {percent}% ({discount})',
        },
        configuration: {
            defaultEmptySelection: 'Ingen',
            incompatible: 'Disse valgmuligheder medfører yderligere ændringer',
            selected: 'Dit valg',
            loadingStatus: 'Vent venligst',
            updatingConfiguration: 'Opdatering af konfiguration og valg',
            changeAlert: {
                many: 'Vi har foretaget {numberOfChanges} ændringer for at tage højde for dette valg',
                one: 'Vi har foretaget 1 ændring for at imødekomme dette valg',
            },
            initialLoading: 'Indlæser konfigurator',
            middleLoading: 'Vi er der næsten…',
            finalLoading: 'Vi er der næsten…',
            exitPrimaryCta: 'Afslut',
            exitTitle: 'Du kan til enhver tid vende tilbage til din konfiguration',
            checkoutTitle: 'Dit unikke møbel',
            shareHeading:
                'Brug dette link til at vende tilbage til dit møbel eller del den med venner og familie',
            shareHelpText:
                'Dette link åbner kun konfigurationen, som den ser ud nu. Hvis du foretager ændringer, skal du oprette et nyt link.',
            mailtoSubject: 'Dit konfigurator link',
            mailtoBody:
                'Tak fordi du bruger vores badmøbel konfigurator Linket til til dit layout er nedenfor:',
            unknownErrorBody: 'Prøv at lukke konfiguratoren og genåbne den igen',
            returnToPlanner: 'Tilbage til konfiguratoren',
            rendererErrorHeading: '3D-gengivelse er ikke tilgængelig',
            rendererErrorBody:
                "Noget er gået galt. Vælg en anden mulighed, eller brug ‘Fortryd' for at gendanne dit tidligere valg",
        },
        space: {
            initialLoading: 'Please wait while we load this set into your space (DK)',
            middleLoading: 'Almost there, please bear with us (DK)',
            finalLoading:
                'This is taking longer than expected, try connecting to wifi for the best experience (DK)',
            exitPrimaryCta: 'Exit 3D space planner (DK)',
            exitTitle: 'Du kan til enhver tid vende tilbage til din konfiguration',
            shareHeading:
                'Use this link to return to this space and share it with friends and family (DK)',
            shareHelpText:
                'This link will only open the space as it looks now. If you make any changes you will need to get a new link (DK).',
            mailtoSubject: 'Your Moda Link (DK)',
            mailtoBody:
                'Thanks for using our 3D space planner, the link to access your layout is below. (DK)',
            returnToPlanner: 'Return to 3D Space Planner (DK)',
            unknownErrorBody: 'Try closing the planner and reopening it again',
        },
    },
};
